"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "generateAppearances", {
    enumerable: true,
    get: function() {
        return generateAppearances;
    }
});
const _weighted = /*#__PURE__*/ _interop_require_default(require("weighted"));
const _getid = require("./get-id");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const defaultConfig = {
    maxTeams: 4,
    minPoints: 40,
    itemCountConfig: {
        options: [
            2,
            3,
            4
        ],
        weights: [
            0.7,
            0.2,
            0.1
        ]
    },
    groupConfig: {
        options: [
            true,
            false
        ],
        weights: [
            0.3,
            0.7
        ],
        perGroup: 2
    },
    propertyConfig: {
        options: [
            "MALE",
            "FEMALE"
        ],
        weights: [
            0.75,
            0.25
        ]
    }
};
// const isSimilar = (item1, item2, range = 10) => Math.abs(item1.points - item2.points) <= range;
const filterBy = (prop)=>(value)=>(items)=>items.filter((item)=>item[prop] === value);
const excludeBy = (prop)=>(values)=>(items)=>items.filter((item)=>!values.includes(item[prop]));
const selectRandomItem = (items)=>items[Math.floor(Math.random() * items.length)];
const createTeam = (usedIds)=>{
    let groupId = (0, _getid.getId)();
    return (selectedItem, remainingItems)=>{
        groupId = (0, _getid.getId)();
        if (usedIds.includes(selectedItem.id)) {
            const availableItems = remainingItems.filter((item)=>!usedIds.includes(item.id));
            if (availableItems.length > 0) {
                selectedItem = selectRandomItem(availableItems);
                remainingItems = remainingItems.filter((item)=>item.id !== selectedItem.id);
            }
        }
        usedIds.push(selectedItem.id);
        return {
            ...selectedItem,
            groupId
        };
    };
};
function pickOption({ options = [], weights = [] }) {
    return _weighted.default.select(options, weights);
}
function generateAppearances({ data = [], config = defaultConfig, output = [], exclude = [], minPoints = 40 }) {
    const { itemCountConfig, propertyConfig, maxTeams } = config;
    let itemAmount = pickOption(itemCountConfig);
    const selectedProperty = pickOption(propertyConfig);
    let filteredItems = filterItems(data, selectedProperty, minPoints);
    let teamCount = 0;
    const assignToGroup = createTeam([]);
    while(itemAmount > 0 && filteredItems.length > 0 && teamCount < maxTeams){
        filteredItems = excludeItems(exclude, filteredItems);
        const selectedItem = selectRandomItem(filteredItems);
        filteredItems = removeItem(selectedItem, filteredItems);
        const groupMember = assignToGroup(selectedItem, filteredItems);
        if (!isGroupInOutput(output, groupMember.groupId)) {
            teamCount++;
        }
        output.push({
            wrestlerId: groupMember.id,
            groupId: groupMember.groupId
        });
        itemAmount--;
    }
    return output;
}
function filterItems(data, selectedProperty, minPoints) {
    return filterBy("gender")(selectedProperty)(data).filter((item)=>item.points >= minPoints && item.active);
}
function excludeItems(exclude, filteredItems) {
    return excludeBy("id")(exclude)(filteredItems);
}
function removeItem(selectedItem, filteredItems) {
    return filteredItems.filter((item)=>item.id !== selectedItem.id);
}
function isGroupInOutput(output, groupId) {
    return output.some((item)=>item.groupId === groupId);
}
